
(() => {
  if (window.MagrionVariantSortLoaded) return;
  window.MagrionVariantSortLoaded = true;

  // Zahlen wie 2,5 / 2.5 / 2,5 mm erkennen.
  const getNumber = (value) => {
    const text = String(value ?? '')
      .trim()
      .replace(/\s+/g, '')
      .replace(/mm$/i, '')
      .replace(',', '.');

    if (!/^[+-]?(?:\d+(?:\.\d+)?|\.\d+)$/.test(text)) {
      return null;
    }

    const number = Number(text);
    return Number.isFinite(number) ? number : null;
  };

  // Dropdown-Werte sortieren.
  const sortDropdown = (select) => {
    const options = Array.from(select.options);
    if (options.length < 2) return;

    const items = options.map((option) => ({
      element: option,
      number: getNumber(option.value)
    }));

    // Nur sortieren, wenn alle Werte numerisch sind.
    if (items.some((item) => item.number === null)) return;

    const sorted = [...items].sort(
      (a, b) => a.number - b.number
    );

    if (sorted.every((item, i) => item === items[i])) return;

    const selectedValue = select.value;

    sorted.forEach((item) => {
      select.appendChild(item.element);
    });

    // Vorherige Auswahl beibehalten.
    select.value = selectedValue;
  };

  // Variantenbuttons einschließlich ihrer Labels sortieren.
  const sortButtons = (group) => {
    const inputs = Array.from(
      group.querySelectorAll(':scope > input[type="radio"]')
    );

    if (inputs.length < 2) return;

    const items = [];

    for (const input of inputs) {
      const label = input.nextElementSibling;

      if (
        !label ||
        label.tagName !== 'LABEL' ||
        label.htmlFor !== input.id
      ) {
        return;
      }

      const number = getNumber(input.value);

      if (number === null) return;

      items.push({ input, label, number });
    }

    const sorted = [...items].sort(
      (a, b) => a.number - b.number
    );

    if (sorted.every((item, i) => item === items[i])) return;

    const fragment = document.createDocumentFragment();

    sorted.forEach(({ input, label }) => {
      fragment.appendChild(input);
      fragment.appendChild(label);
    });

    group.appendChild(fragment);
  };

  const sortPicker = (picker) => {
    picker.querySelectorAll('.product-form__input').forEach(
      (group) => {
        const select = group.querySelector('select');

        if (select) {
          sortDropdown(select);
        } else {
          sortButtons(group);
        }
      }
    );
  };

  // Bei dynamisch nachgeladenen Varianten erneut sortieren.
  const observer = new MutationObserver((mutations) => {
    const pickers = new Set();

    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        if (node.matches('variant-selects')) {
          pickers.add(node);
        }

        node.querySelectorAll('variant-selects').forEach(
          (picker) => pickers.add(picker)
        );

        const parentPicker = node.closest('variant-selects');

        if (parentPicker) {
          pickers.add(parentPicker);
        }
      });
    });

    pickers.forEach(sortPicker);
  });

  const start = () => {
    document.querySelectorAll('variant-selects').forEach(
      sortPicker
    );

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {
      once: true
    });
  } else {
    start();
  }
})();
